import React from 'react'
import {FormInput} from '@modifi/plugin-forms'
import {KEY_JANUS, useTranslation} from '@modifi/plugin-i18n'
import {InputContainer, SelectPure} from '@modifi/ui'
import * as PropTypes from 'prop-types'

import {RequiredLabel} from '../../styles'
import {productOptions} from '../../constants'

const SelectWithContainer = props => <InputContainer inputComponent={SelectPure} {...props} />

const ProductTypeSelect = ({locale}) => {
  const {t} = useTranslation(KEY_JANUS)
  let translatedProductOptions = productOptions.map(({label, value}) => ({
    value,
    label: t(label),
  }))

  if (locale === 'de_DE') {
    translatedProductOptions = translatedProductOptions.filter(
      ({value}) => value !== 'Seller finance'
    )
  }

  // hiding shipment tracker until its ready for China
  if (['zh_CN', 'zh_TW'].includes(locale)) {
    translatedProductOptions = translatedProductOptions.filter(
      ({value}) => value !== 'Shipment tracker' && value !== 'Buyer finance'
    )
  }

  return (
    <FormInput
      inputComponent={SelectWithContainer}
      name="productType"
      label={<RequiredLabel>{t('signup.product-type.label')}</RequiredLabel>}
      placeholder={t('signup.product-type.placeholder')}
      options={translatedProductOptions}
      backspaceRemovesValue={false}
      isSearchable={false}
      oneOf={translatedProductOptions.map(({value}) => value)}
      oneOfMessage="tr:product-type.error.one-of"
      noBlur
      isRequired
    />
  )
}
ProductTypeSelect.propTypes = {
  locale: PropTypes.string.isRequired,
}

export default ProductTypeSelect
